<template>
  <transition name="el-fade-in-linear">
    <div
      v-if="show"
      v-click-outside="close"
      ref="set_up_body"
      class="set_up_body"
    >
      <VirtualScrollbar ref="virtualScrollbar">
        <div class="set_up_body_div">
          <!-- <div
            class="risk_box can"
            @click="
              $parent.openPopup({
                type: 'disclaimerPopup',
                data: {
                  circle_id,
                  disclaimer,
                  circleSecond: 0,
                },
              })
            "
          >
            <img
              class="icon_risk"
              src="@/assets/img/circleV2/icon_risk.png"
              alt=""
            />
            <div>圈子风险提示</div>
            <i class="icon_arrow el-icon-arrow-right" />
          </div> -->
          <div class="block_cell">
            <div class="title">群公告</div>
            <div class="announcement">
              <VirtualScrollbar>
                <div>{{ notice || "暂无群公告" }}</div>
              </VirtualScrollbar>
            </div>
          </div>
          <div
            class="block_cell"
            style="
              height: calc(100% - 34px - 12px - 210px - 12px - 40px - 12px);
            "
          >
            <div class="title">群成员</div>
            <div class="member_cell_list">
              <div class="member_cells">
                <div
                  v-for="(item, index) in userList"
                  :key="index"
                  class="member_cell"
                >
                  <div>
                    <img class="avatar" :src="item.user.avatar" alt="" />
                  </div>
                  <div class="nickname">
                    <div class="hang1" :title="item.user.nickname">
                      {{ item.user.nickname }}
                    </div>
                  </div>
                </div>
              </div>
              <TouchTheBottom
                ref="touchTheBottom"
                id-name="circleMemberList"
                @getMore="getCircleUserList(page)"
              />
            </div>
          </div>
          <div class="btn_logout" @click="handleLogout">退出圈子</div>
        </div>
      </VirtualScrollbar>
    </div>
  </transition>
</template>

<script>
import request from "@/utils/request";
import { Debounce } from "@/utils/debounce";
import { ClickOutside as vClickOutside } from "element-plus";
export default {
  directives: {
    "click-outside": vClickOutside, // 局部注册指令
  },
  data() {
    return {
      show: false,
      circle_id: null,
      notice: "",
      disclaimer: "",
      page: 1,
      limit: 60,
      userList: [],
    };
  },
  methods: {
    setData(e) {
      this.circle_id = e.circle_id;
      this.notice = e.notice;
      this.disclaimer = e.disclaimer;
    },
    open() {
      this.show = true;
      setTimeout(() => {
        this.getCircleUserList(1);
      });
    },
    close() {
      this.show = false;
    },
    // changeShow () {
    //   const show = this.show
    //   show ? this.close() : this.open()
    // },
    async getCircleUserList(page) {
      const res = await request.post("/teacher/circle/getCircleUserList", {
        circle_id: this.circle_id,
        page,
        limit: this.limit,
      });
      const totalCount = res.data.total;
      const userListNew = res.data.data;
      const userList = this.userList;
      this.userList = page === 1 ? userListNew : userList.concat(userListNew);
      this.page = page + 1;
      setTimeout(() => {
        this.$refs.virtualScrollbar.update();
        this.$refs.touchTheBottom.updateLoading(
          totalCount > this.userList.length ? 1 : 3
        );
      });
    },
    // 退出圈子
    handleLogout: Debounce(function () {
      this.$confirm(
        "确认要退出该圈子吗？退出后将接收不到老师发送的关键消息呦~",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        // console.log('退出圈子')
        this.handleLogoutApi();
      });
    }),
    handleLogoutApi: Debounce(async function () {
      const res = await request.post("/api/circle/leaveCircle", {
        uid: this.circle_id,
      });
      if (res.code === 1) {
        this.$message({
          type: "success",
          message: res.msg,
        });
        window.location.reload();
      }
    }),
  },
};
</script>

<style scoped>
.set_up_body {
  position: absolute;
  top: 56px;
  right: 0;
  width: 360px;
  height: calc(100% - 56px);
  background: #ffffff;
  box-shadow: -8px 0 20px 0px rgba(0, 0, 0, 0.1);
  z-index: 3;
}

.set_up_body_div {
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
}

.risk_box {
  width: 328px;
  height: 34px;
  box-sizing: border-box;
  padding: 0 10px;
  background: #ffeeee;
  border-radius: 4px;
  border: 1px solid #ffdcdc;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 12px;
  color: #f93636;
  cursor: pointer;
  user-select: none;
}

.icon_risk {
  width: 16px;
  height: 16px;
  display: block;
  margin-right: 6px;
  display: block;
  flex-shrink: 0;
}

.risk_box > div {
  width: 100%;
}

.risk_box .icon_arrow {
  flex-shrink: 0;
  font-weight: bolder;
}

.block_cell {
}

.block_cell .title {
  height: 20px;
  font-weight: 400;
  font-size: 15px;
  color: #333333;
  margin-bottom: 10px;
}

.announcement {
  width: 100%;
  height: 180px;
  background: #f6f6f6;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 10px 8px;
  font-weight: 400;
  font-size: 13px;
  color: #666666;
}

.member_cell_list {
  width: 100%;
  /* position: relative;
  left: -16px;
  width: 360px;
  height: calc(100% - 20px - 10px); */
}

.member_cells {
  /* box-sizing: border-box; */
  /* padding: 0 16px; */
  display: flex;
  flex-wrap: wrap;
  gap: 12px 8px;
}

.member_cell {
  width: 48px;
}

.member_cell .avatar {
  width: 48px;
  height: 48px;
  display: block;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  flex-shrink: 0;
  border-radius: 50%;
  margin-bottom: 6px;
}

.member_cell .nickname {
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  text-align: center;
}

.btn_logout {
  height: 40px;
  border-radius: 6px;
  border: 1px solid #ffdcdc;
  font-weight: 400;
  font-size: 13px;
  color: #f93636;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
}

.btn_logout:hover {
  background-color: #f93636;
  color: #fff;
}
</style>
